export type Locale = 'pt' | 'en';

export const STRINGS = {
  pt: {
    boot: 'Carregando…',
    brand: 'KAZBIA ONLINE',
    authLede: 'MMO idle com as fórmulas, monstros e hunts do Tibia 15.30.',
    account: 'Conta',
    password: 'Senha',
    invite: 'Convite (beta)',
    createAccount: 'Criar conta',
    signIn: 'Entrar',
    haveAccount: 'Já tenho conta',
    newAccount: 'Criar conta',
    playNow: 'Jogar agora',
    playNowHint: 'Entra sem cadastro. Depois você reivindica a conta para salvar.',
    authOr: 'ou',
    selectYourChar: 'Seus personagens',
    selectEmpty: 'Nenhum personagem ainda. Dê um nome ao seu primeiro herói abaixo e entre no mundo.',
    selectEnter: 'Entrar',
    selectLogout: 'Sair da conta',
    selectCreateSection: 'Novo personagem',
    selectSlotsFull: 'Todos os slots em uso.',
    charSlots: 'Personagens',
    createChar: 'CRIE SEU PERSONAGEM',
    createCharLede: 'Dê um nome ao seu herói e entre no mundo.',
    createCharHint: 'Só o nome. Todo mundo começa como Rookie level 1: a arma você escolhe ao entrar, a vocação no level 8.',
    name: 'Nome',
    sex: 'Sexo',
    male: 'Masculino',
    female: 'Feminino',
    vocation: 'Vocação',
    knightWeapon: 'Arma inicial do Knight',
    create: 'Criar personagem',
    cancel: 'Cancelar',
    close: 'Fechar',
    helper: 'Helper',
    hunts: 'Hunts',
    rotation: 'Rotação',
    filters: 'Filtros',
    searchHunt: 'Buscar cave, hunt, cidade…',
    bestForYou: 'melhor para você',
    stopHunt: 'Encerrar hunt',
    openHelper: 'Abrir Helper',
    openHelperSpells: 'Configurar magias de ataque',
    openHunts: 'Escolher hunt',
    pickHunt: 'Escolha uma hunt para entrar na cave.',
    welcome: 'Bem-vindo. Clique no nome da hunt para entrar numa cave.',
    helperNone: 'Nenhuma',
    helperAuto: 'automática',
    helperShieldHint: 'utamo vita: 50 mana, 200s, sorcerer e druid. Só recasta quando o HP estiver abaixo do limite. Dano vira mana enquanto ativo e HP baixo. Energy ring também ativa o escudo.',
    helperEquipHint: 'O Helper usa o que você já tem equipado. Troque o gear na backpack com Organizar.',
    helperTauntHint: 'Provocar puxa um monstro a mais para o pack.',
    helperAutoAttack: 'Ataque automático',
    helperFlee: 'Fugir abaixo de',
    helperStopSupplies: 'Parar sem supplies',
    helperLoot: 'Não pegar loot abaixo de',
    helperKeepAll: 'guardar tudo',
    helperSpellsHint: 'A primeira magia da lista é a prioridade. Desligar tira da rotação.',
    helperNoSpells: 'Nenhuma magia de ataque neste nível.',
    helperUse: 'usar',
    yes: 'sim',
    no: 'não',
    queueTitle: 'FILA DE ENTRADA',
    queueWait: 'Aguarde sua vez para entrar na hunt.',
    leaveQueue: 'Sair da fila',
    slots: 'vagas',
    queued: 'na fila',
    loop: 'Loop',
    decorate: 'Decorar',
    sell: 'venda',
    lootFilterOff: 'off',
    next: 'Próximo',
    skip: 'Pular tutorial',
    gotIt: 'Entendi',
    logout: 'sair',
    settings: 'Opções',
    settingsLang: 'Idioma',
    settingsHint: 'Loop: ao terminar uma caçada (stamina ou morte), o personagem volta para a mesma caçada. Preferências salvas automaticamente neste navegador.',
    chatPh: 'Mensagem…',
    firstHunt: 'Primeira hunt iniciada. O personagem caça sozinho.',
    entered: 'Entrou em',
    blocked: 'bloqueada',
    tip1: 'O personagem caça sozinho. Olhe o viewport: cada kill já conta XP e loot.',
    tip2: 'O Hunt Analyzer à esquerda é o jogo: XP/h, loot, supplies e o Balance.',
    tip3: 'Quando subir de nível, use Organizar no Set para comprar gear melhor.',
    tip4: 'No Helper você configura cura, poções, haste, comida, runas e magias.',
    tip5: 'Stamina é o seu tempo de caçada (12h): só gasta caçando e recarrega no mesmo ritmo em qualquer outro lugar, até deslogado.',
    awayTitle: 'Enquanto você esteve fora',
    awayXp: 'Experiência',
    awayKills: 'Kills',
    awayLoot: 'Loot',
    awaySupplies: 'Supplies',
    awayLevels: 'Níveis',
    awayEfficiency: 'Eficiência',
    awayCap: 'Teto',
    connectionLost: 'CONEXÃO PERDIDA — Reconectando…',
    partyDuo: 'Duo',
    party4: 'Party x4',
    partyNeed: 'precisa de party',
    hotbarHint: 'clique: prioridade · direito: ligar/desligar',
    huntEnded: 'Hunt encerrada',
    endedDied: 'Você morreu.',
    endedDiedXp: 'Experiência perdida',
    endedDiedSkills: 'Skills perdidas',
    endedDiedBlessings: 'bênção(ões) consumida(s)',
    endedDiedAol: 'Amulet of Loss protegeu o loot e foi destruído.',
    endedDiedLoot: 'do loot da pouch foi perdido.',
    endedDiedHint: 'Compre bênçãos no ícone ao lado do amuleto no Set para perder menos XP/skills e proteger o loot.',
    endedFled: 'Você fugiu com o HP baixo. Ajuste a cura no Helper.',
    endedSupplies: 'Acabaram os supplies. O Loop religa a cave se estiver ligado.',
    endedStamina: 'A stamina acabou — voltando para a cidade. Ela recarrega enquanto você não está caçando.',
    endedSession: 'Sua sessão de hunt gratuita terminou — voltando para a cidade. Você pode sair de novo em seguida; o premium remove o limite.',
    endedStopped: 'Você saiu da hunt.',
    worldOnline: 'personagens no mundo',
    worldEvent: 'Evento',
    worldNone: 'Nenhum evento ativo',
    supplyHours: 'Supplies para quantas horas? O ouro sai na entrada; o que sobrar fica na bolsa de supplies para a próxima hunt. A bolsa e o armazém são usados antes da loja.',
    switchHint: 'Clique em outra cave para trocar. A hunt atual encerra e as potions que sobrarem ficam na bolsa de supplies.',
    huntingHere: 'caçando aqui',
    packWhatYouCan: 'compra o que o ouro der',
    noHuntMatch: 'Nenhuma cave com esse nome.',
    loadingHunts: 'Carregando caves…',
    huntError: 'Não deu para entrar nessa cave.',
    bestiaryUnlock: 'Bestiary: 10 kills registrados. Abra Cyclopedia para ver as espécies.',
    supplies: 'supplies',
    needGold: 'ouro insuficiente',
    inspectSell: 'Venda',
    inspectNone: 'sem valor de NPC',
    setTitle: 'Set',
    blessTitle: 'Bênçãos',
    blessRecord: 'Registro de Bênçãos',
    blessEffect: 'Efeito na penalidade de morte',
    blessPerkXp: 'Cada bênção reduz 8% da perda de XP e skills (5 = 40% menos).',
    blessPerkLoot: 'Com qualquer bênção ativa, o loot da pouch fica protegido.',
    blessPerkConsume: 'Todas as bênçãos são consumidas ao morrer.',
    blessBuyAll: 'Comprar todas que faltam',
    blessAllOwned: 'Todas as bênçãos ativas',
    blessUnitPrice: 'Preço por bênção',
    blessFull: 'proteção completa',
    blessHint: 'Clique para abrir o registro de bênçãos',
    slotAmulet: 'Amuleto',
    slotRing: 'Anel',
    slotTrinket: 'Berloque',
    organize: 'Organizar',
    stash: 'guardar',
    helperLootHint: 'Drops das criaturas vão para o Loot Pouch. Venda ou guarde no armazém; o filtro deixa no chão o loot barato (nada é vendido ao cair).',
    helperLootDepot: 'Ao encerrar a hunt',
    helperLootKeep: 'guardar no armazém',
    helperLootSell: 'vender o pouch',
    helperModeHint: 'Caçada é o padrão. Boss vale nos bosses e na Arena.',
    helperRuneHint: 'Runas entram no grupo de ataque das magias: o Helper joga a que der mais dano naquele tick.',
    helperRune: 'Runa de ataque',
    helperSupportHint: 'Haste reduz o quanto melee acerta quem luta à distância. Comida aumenta a regeneração. Curas (exana pox/flam/vis/mort/frigo) limpam condições de combate.',
    helperFood: 'Comer (cogumelos)',
    helperHaste: 'Haste',
    helperCure: 'Curar condições (exana *)',
    equip: 'Equipar',
    unequip: 'Desequipar',
    exalt: 'Exaltar',
    help1: 'Clique em CAÇAR para abrir as caçadas: todas estão liberadas, e tiers mais altos pagam mais.',
    help2: 'Poções e runas não ficam no inventário: clique num slot da barra de ações para criar a regra — cada uso cobra o gold na hora.',
    help3: 'Balance = loot − supplies. Se estiver negativo, mude de cave ou de gear.',
    help4: 'Stamina 12h = tempo de caçada. Gasta só caçando, recarrega 1 min por min fora da caçada. O "+" compra 4h com gold (3× por dia).',
    help5: 'A recompensa diária é uma arma de treino. Parado 2 minutos na cidade, o personagem treina sozinho.',
    help6: 'Guest: depois do tutorial, reivindique a conta para não perder o personagem.',
    help7: 'O loot volta na mochila: use Despachar loot — as marcas ficam salvas para as próximas caçadas.',
    help8: 'Bênçãos ficam no templo (BÊNÇÃOS): reduzem a perda na morte e são de graça abaixo do level 80.',
    // Remake Phase 1A — full-screen HUD
    hudInventory: 'Inventário',
    hudLoot: 'Loot da sessão',
    hudAnalyzer: 'Analisador de caçada',
    hudChat: 'Chat',
    hudStatus: 'Personagem',
    hudTask: 'Task',
    hudParty: 'Party',
    hudMinimize: 'Minimizar',
    hudExpand: 'Expandir',
    hudResetLayout: 'Reorganizar janelas',
    hudOutfit: 'Outfit',
    hudDepot: 'Depot',
    hudMarket: 'Mercado',
    hudImbuements: 'Imbuements',
    hudForge: 'Forja',
    hudBlessings: 'Blessings',
    hudHuntDetails: 'Detalhes da caçada',
    hudSellLoot: 'Vender loot',
    hudStopHunt: 'Sair da caçada',
    hudChangeRoom: 'Trocar skill',
    hudLeaveTraining: 'Sair do treino',
    hudHunt: 'Caçar',
    hudTraining: 'Treino',
    hudTown: 'Cidade',
    hudXpBonus: 'Bônus de experiência ativo',
    hudXpBonusShort: 'Taxa de XP',
    hudGold: 'Gold',
    hudCoins: 'Tibia Coins',
    hudBuyCoins: 'Obter Tibia Coins',
    hudOnline: 'Jogadores online',
    navHelper: 'Helper',
    navCyclopedia: 'Cyclopedia',
    navMarket: 'Mercado',
    navStore: 'Loja',
    navVip: 'VIP',
    navRank: 'Rank',
    navBuild: 'Build',
    navProgressao: 'Progressão',
    navRoleta: 'Roleta',
    navDepot: 'Depot',
    hudHealthPotion: 'Poção de vida',
    hudManaPotion: 'Poção de mana',
    hudSpiritPotion: 'Poção espiritual',
    hudRune: 'Runa de ataque',
    hudSoulRune: 'Runa de soul',
    hudSupportRune: 'Runa de suporte',
    hudHealSpell: 'Magia de cura',
    hudStamina: 'Stamina',
    hudActionBar: 'Barra de ações',
    hudAutoAttack: 'Ataque automático',
    hudEmptySlot: 'Configurar poções e runas no Helper',
    hudConfigure: 'configurar',
    hudLoopHint: 'Repete a mesma hunt quando ela termina',
    hudHpPotionShort: 'Poção HP',
    hudFlee: 'Fugir',
    hudFleeHint: 'Sai da hunt quando a vida cai abaixo deste limite',
    // Remake Phase 1B — reference HUD
    hudEquipped: 'Equipado',
    hudXpRateShort: 'Taxa de exp',
    hudSatchel: 'Bolsa',
    hudSatchelHint: 'Nada aqui é vendido, vendido rápido ou usado para loot — mas anéis e amuletos equipados se repõem daqui.',
    hudBackpack: 'Mochila',
    hudNoBackpack: 'Equipe uma mochila para guardar itens aqui.',
    hudCapacity: 'Capacidade',
    hudAutoRules: 'Deixe uma barra de regras colocar e tirar as peças deste slot por você nas lutas.',
    hudLootEmpty: 'Nada aqui ainda — vá caçar!',
    hudLootFoot: 'Clique para pegar — expira em 15 min',
    hudSessionNow: 'Sessão atual',
    hudNextLevel: 'Próximo level',
    hudXpTotal: 'Exp total',
    hudXpHour: 'Exp/h',
    hudProfitTotal: 'Lucro total',
    hudProfitHour: 'Lucro/h',
    hudAnalyzerTag: 'Acompanhe XP, lucro e o desempenho da caçada.',
    hudAnalyzerFull: 'Análise completa',
    hudBuyStamina: 'Comprar stamina com gold',
    hudStaminaTitle: 'Stamina {clock} — gasta caçando, recarrega em qualquer outro lugar',
    hudPreset: 'Conjunto',
    hudTarget: 'Alvo',
    hudTargetNearest: 'Mais próximo',
    hudTargetBoss: 'Boss',
    hudTargetFollow: 'Seguir o líder',
    hudTargetLowHp: 'Menor vida',
    hudTargetHighHp: 'Maior vida',
    hudTargetLowPct: 'Menor % de vida',
    hudTargetHighPct: 'Maior % de vida',
    hudTargetHint: 'Qual criatura do grupo o personagem ataca primeiro',
    presetHunt: 'Caçada',
    presetBoss: 'Boss',
    presetPvp: 'PvP',
    presetOpen: 'Abrir o Helper…',
    hudStanceDef: 'Defesa total',
    hudStanceBal: 'Equilibrado',
    hudStance: 'Postura',
    hudStanceAtk: 'Ataque total',
    hudStanceAtkPal: 'Ataque total (utito tempo san, lvl 60)',
    hudLoopShort: 'Loop: repete a mesma hunt',
    hudTauntShort: 'Puxar mais criaturas (taunt)',
    hudHasteShort: 'Haste automático',
    hudMore: 'Escolher outra caçada',
    hudLogout: 'Sair do jogo',
    hudConfigureSlot: 'Definir ação',
    hudQuickSell: 'Venda rápida',
    hudOverflowHead: 'Não coube na mochila — clique para pegar (expira em 15 min)',
    hudDispatchLoot: 'Despachar loot',
    hudFree: 'Grátis',
    hudPerUse: 'por uso',
    hudLogoutKeep: 'Voltar aos personagens (a caçada continua)',
    hudLogoutEnd: 'Encerrar a caçada e voltar aos personagens',
    navCharacter: 'Personagem',
    navHunt: 'Caçar',
    navTask: 'Task',
    navParty: 'Party',
    navWiki: 'Wiki',
    navRanking: 'Ranking',
    navOptions: 'Opções',
    navPrey: 'Prey',
    navFriends: 'Amigos',
    navGuild: 'Guild',
    navSupport: 'Fale com a gente',
    navInvite: 'Convidar',
    navMore: 'Mais',
    navPremium: 'Premium',
    chatGlobal: 'Global',
    chatMarket: 'Mercado',
    chatLocal: 'Local',
    chatPhLocal: 'Fale com quem está por perto...',
    chatParty: 'Party',
    chatPhParty: 'Fale com a sua party...',
    chatSystem: 'Sistema',
    chatCombat: 'Combate',
    chatSend: 'Enviar',
    chatNeedLevel: 'Você precisa do level 20 para falar neste canal.',
    chatPhGlobal: 'Fale com todo mundo online...',
    chatPhMarket: 'Anuncie compras e vendas...',
    chatCombatHint: 'O que seu personagem faz em combate aparece aqui.',
  },
  en: {
    boot: 'Loading…',
    brand: 'KAZBIA ONLINE',
    authLede: 'Idle MMO using Tibia 15.30 formulas, monsters and hunts.',
    account: 'Account',
    password: 'Password',
    invite: 'Invite (beta)',
    createAccount: 'Create account',
    signIn: 'Sign in',
    haveAccount: 'I already have an account',
    newAccount: 'Create account',
    playNow: 'Play now',
    playNowHint: 'Jump in without signing up. Claim the account later to keep it.',
    authOr: 'or',
    selectYourChar: 'Your characters',
    selectEmpty: 'No characters yet. Name your first hero below and step into the world.',
    selectEnter: 'Enter',
    selectLogout: 'Log out',
    selectCreateSection: 'New character',
    selectSlotsFull: 'All character slots are in use.',
    charSlots: 'Characters',
    createChar: 'CREATE YOUR CHARACTER',
    createCharLede: 'Name your hero and step into the world.',
    createCharHint: 'Just the name. Everyone starts as a level 1 Rookie: you pick a weapon on entering and a vocation at level 8.',
    name: 'Name',
    sex: 'Sex',
    male: 'Male',
    female: 'Female',
    vocation: 'Vocation',
    knightWeapon: 'Knight starting weapon',
    create: 'Create character',
    cancel: 'Cancel',
    close: 'Close',
    helper: 'Helper',
    hunts: 'Hunts',
    rotation: 'Rotation',
    filters: 'Filters',
    searchHunt: 'Search cave, hunt, city…',
    bestForYou: 'best for you',
    stopHunt: 'Stop hunt',
    openHelper: 'Open Helper',
    openHelperSpells: 'Configure attack spells',
    openHunts: 'Pick a hunt',
    pickHunt: 'Pick a hunt to enter the cave.',
    welcome: 'Welcome. Click the hunt name to enter a cave.',
    helperNone: 'None',
    helperAuto: 'automatic',
    helperShieldHint: 'utamo vita: 50 mana, 200s, sorcerer and druid. Only recasts when HP is below the limit. Damage becomes mana while active and HP is low. An energy ring also turns the shield on.',
    helperEquipHint: 'The Helper uses what you already wear. Change gear with Organize in the backpack.',
    helperTauntHint: 'Taunt pulls one extra monster into the pack.',
    helperAutoAttack: 'Auto-attack',
    helperFlee: 'Flee below',
    helperStopSupplies: 'Stop without supplies',
    helperLoot: 'Do not pick up loot below',
    helperKeepAll: 'keep everything',
    helperSpellsHint: 'The first spell in the list is the priority. Turning one off removes it from the rotation.',
    helperNoSpells: 'No attack spells at this level.',
    helperUse: 'use',
    yes: 'yes',
    no: 'no',
    queueTitle: 'ENTRY QUEUE',
    queueWait: 'Wait your turn to enter the hunt.',
    leaveQueue: 'Leave queue',
    slots: 'slots',
    queued: 'queued',
    loop: 'Loop',
    decorate: 'Decorate',
    sell: 'sell',
    lootFilterOff: 'off',
    next: 'Next',
    skip: 'Skip tutorial',
    gotIt: 'Got it',
    logout: 'leave',
    settings: 'Options',
    settingsLang: 'Language',
    settingsHint: 'Loop: when a hunt ends (stamina or death) the character goes back to the same hunt. Preferences are saved in this browser.',
    chatPh: 'Message…',
    firstHunt: 'First hunt started. The character hunts on its own.',
    entered: 'Entered',
    blocked: 'locked',
    tip1: 'The character hunts on its own. Watch the viewport: every kill already counts XP and loot.',
    tip2: 'The Hunt Analyzer on the left is the game: XP/h, loot, supplies and Balance.',
    tip3: 'When you level up, use Organize on the Set to buy better gear.',
    tip4: 'In Helper you set healing, potions, haste, food, runes and spells.',
    tip5: 'Stamina is your hunting time (12h): it burns only while hunting and refills at the same speed anywhere else, even logged out.',
    awayTitle: 'While you were away',
    awayXp: 'Experience',
    awayKills: 'Kills',
    awayLoot: 'Loot',
    awaySupplies: 'Supplies',
    awayLevels: 'Levels',
    awayEfficiency: 'Efficiency',
    awayCap: 'Cap',
    connectionLost: 'CONNECTION LOST — Reconnecting…',
    partyDuo: 'Duo',
    party4: 'Party x4',
    partyNeed: 'needs a party',
    hotbarHint: 'click: priority · right-click: on/off',
    huntEnded: 'Hunt ended',
    endedDied: 'You are dead.',
    endedDiedXp: 'Experience lost',
    endedDiedSkills: 'Skill levels lost',
    endedDiedBlessings: 'blessing(s) consumed',
    endedDiedAol: 'Amulet of Loss protected your loot and was destroyed.',
    endedDiedLoot: 'of pouch loot was lost.',
    endedDiedHint: 'Buy blessings from the icon next to the amulet slot in Set to lose less XP/skills and protect loot.',
    endedFled: 'You fled with low HP. Tune healing in Helper.',
    endedSupplies: 'Supplies ran out. Loop restarts the cave if it is on.',
    endedStamina: 'Out of stamina — heading back to the city. It refills while you are not hunting.',
    endedSession: 'Your free hunt session is over — heading back to the city. You can head right back out; premium removes the limit.',
    endedStopped: 'You left the hunt.',
    worldOnline: 'characters online',
    worldEvent: 'Event',
    worldNone: 'No event running',
    supplyHours: 'Supplies for how many hours? Gold is spent on entry; leftovers stay in your supply pouch for the next hunt. Pouch and warehouse are used before the shop.',
    switchHint: 'Click another cave to switch. The current hunt ends and leftover potions stay in your supply pouch.',
    huntingHere: 'hunting here',
    packWhatYouCan: 'buys what the gold covers',
    noHuntMatch: 'No cave matches that name.',
    loadingHunts: 'Loading caves…',
    huntError: 'Could not enter that cave.',
    bestiaryUnlock: 'Bestiary: 10 kills logged. Open Cyclopedia to see the species.',
    supplies: 'supplies',
    needGold: 'not enough gold',
    inspectSell: 'Sell',
    inspectNone: 'no NPC value',
    setTitle: 'Set',
    blessTitle: 'Blessings',
    blessRecord: 'Record of Blessings',
    blessEffect: 'Effect on Death Penalty',
    blessPerkXp: 'Each blessing reduces XP/skill loss by 8% (5 = 40% less).',
    blessPerkLoot: 'With any blessing active, your loot pouch is protected.',
    blessPerkConsume: 'All blessings are consumed when you die.',
    blessBuyAll: 'Buy all missing',
    blessAllOwned: 'All blessings active',
    blessUnitPrice: 'Price per blessing',
    blessFull: 'full protection',
    blessHint: 'Click to open the blessing record',
    slotAmulet: 'Amulet',
    slotRing: 'Ring',
    slotTrinket: 'Trinket',
    organize: 'Organize',
    stash: 'stash',
    helperLootHint: 'Creature drops go to the Loot Pouch. Sell or stash them; the filter leaves cheap loot on the floor (nothing is sold as it drops).',
    helperLootDepot: 'When the hunt ends',
    helperLootKeep: 'keep in warehouse',
    helperLootSell: 'sell the pouch',
    helperModeHint: 'Hunt is the default. Boss applies on boss fights and the Arena.',
    helperRuneHint: 'Runes share the spell attack group: the Helper throws whichever hits harder that tick.',
    helperRune: 'Attack rune',
    helperSupportHint: 'Haste cuts how often melee lands on a kiting character. Food raises regeneration. Cures (exana pox/flam/vis/mort/frigo) clear combat conditions.',
    helperFood: 'Eat (mushrooms)',
    helperHaste: 'Haste',
    helperCure: 'Cure conditions (exana *)',
    equip: 'Equip',
    unequip: 'Unequip',
    exalt: 'Exalt',
    help1: 'Click HUNT to open the hunts: all of them are open, and higher tiers pay more.',
    help2: 'Potions and runes are not carried: click an action-bar slot to make the rule — every use charges its gold.',
    help3: 'Balance = loot − supplies. If it is negative, change cave or gear.',
    help4: 'Stamina 12h = hunting time. It burns only while hunting and refills 1 min per min out of a hunt. "+" buys 4h with gold (3× a day).',
    help5: 'The daily reward is a training weapon. Idle 2 minutes in town, the character trains by itself.',
    help6: 'Guest: after the tutorial, claim the account so you do not lose the character.',
    help7: 'Loot comes home in the backpack: use Dispatch loot — your marks are saved for the next hunts.',
    help8: 'Blessings are at the temple (BLESSINGS): they cut the death loss and are free below level 80.',
    // Remake Phase 1A — full-screen HUD
    hudInventory: 'Inventory',
    hudLoot: 'Session loot',
    hudAnalyzer: 'Hunt analyzer',
    hudChat: 'Chat',
    hudStatus: 'Character',
    hudTask: 'Task',
    hudParty: 'Party',
    hudMinimize: 'Minimize',
    hudExpand: 'Expand',
    hudResetLayout: 'Reset window layout',
    hudOutfit: 'Outfit',
    hudDepot: 'Depot',
    hudMarket: 'Market',
    hudImbuements: 'Imbuements',
    hudForge: 'Forge',
    hudBlessings: 'Blessings',
    hudHuntDetails: 'Hunt details',
    hudSellLoot: 'Sell loot',
    hudStopHunt: 'Leave hunt',
    hudChangeRoom: 'Change skill',
    hudLeaveTraining: 'Leave training',
    hudHunt: 'Hunt',
    hudTraining: 'Training',
    hudTown: 'Town',
    hudXpBonus: 'Active experience bonus',
    hudXpBonusShort: 'XP rate',
    hudGold: 'Gold',
    hudCoins: 'Tibia Coins',
    hudBuyCoins: 'Get Tibia Coins',
    hudOnline: 'Players online',
    navHelper: 'Helper',
    navCyclopedia: 'Cyclopedia',
    navMarket: 'Market',
    navStore: 'Store',
    navVip: 'VIP',
    navRank: 'Highscores',
    navBuild: 'Build',
    navProgressao: 'Progression',
    navRoleta: 'Roulette',
    navDepot: 'Depot',
    hudHealthPotion: 'Health potion',
    hudManaPotion: 'Mana potion',
    hudSpiritPotion: 'Spirit potion',
    hudRune: 'Attack rune',
    hudSoulRune: 'Soul rune',
    hudSupportRune: 'Support rune',
    hudHealSpell: 'Healing spell',
    hudStamina: 'Stamina',
    hudActionBar: 'Action bar',
    hudAutoAttack: 'Auto-attack',
    hudEmptySlot: 'Set potions and runes in the Helper',
    hudConfigure: 'configure',
    hudLoopHint: 'Restarts the same hunt when it ends',
    hudHpPotionShort: 'HP potion',
    hudFlee: 'Flee',
    hudFleeHint: 'Leaves the hunt when health drops below this threshold',
    // Remake Phase 1B — reference HUD
    hudEquipped: 'Equipped',
    hudXpRateShort: 'Exp rate',
    hudSatchel: 'Pouch',
    hudSatchelHint: 'Nothing here is sold, quick-sold or used for loot — but equipped rings and amulets refill from here.',
    hudBackpack: 'Backpack',
    hudNoBackpack: 'Equip a backpack to store items here.',
    hudCapacity: 'Capacity',
    hudAutoRules: 'Let a rule bar put on and take off the pieces in this slot for you in fights.',
    hudLootEmpty: 'Nothing here yet — go hunt!',
    hudLootFoot: 'Click to take — expires after 15 min',
    hudSessionNow: 'Current session',
    hudNextLevel: 'Next level',
    hudXpTotal: 'Total exp',
    hudXpHour: 'Exp/h',
    hudProfitTotal: 'Total profit',
    hudProfitHour: 'Profit/h',
    hudAnalyzerTag: 'Track XP, profit and hunt performance.',
    hudAnalyzerFull: 'Full analysis',
    hudBuyStamina: 'Buy stamina with gold',
    hudStaminaTitle: 'Stamina {clock} — spent hunting, refills anywhere else',
    hudPreset: 'Preset',
    hudTarget: 'Target',
    hudTargetNearest: 'Nearest',
    hudTargetBoss: 'Boss',
    hudTargetFollow: 'Follow the leader',
    hudTargetLowHp: 'Lowest health',
    hudTargetHighHp: 'Highest health',
    hudTargetLowPct: 'Lowest health %',
    hudTargetHighPct: 'Highest health %',
    hudTargetHint: 'Which creature of the pack the character attacks first',
    presetHunt: 'Hunt',
    presetBoss: 'Boss',
    presetPvp: 'PvP',
    presetOpen: 'Open the Helper…',
    hudStanceDef: 'Full defense',
    hudStanceBal: 'Balanced',
    hudStance: 'Stance',
    hudStanceAtk: 'Full attack',
    hudStanceAtkPal: 'Full attack (utito tempo san, lvl 60)',
    hudLoopShort: 'Loop: restart the same hunt',
    hudTauntShort: 'Pull more creatures (taunt)',
    hudHasteShort: 'Auto haste',
    hudMore: 'Pick another hunt',
    hudLogout: 'Leave game',
    hudConfigureSlot: 'Assign action',
    hudQuickSell: 'Quick sell',
    hudOverflowHead: 'Did not fit in the backpack — click to pick up (expires in 15 min)',
    hudDispatchLoot: 'Send loot to depot',
    hudFree: 'Free',
    hudPerUse: 'per use',
    hudLogoutKeep: 'Back to characters (keep hunting)',
    hudLogoutEnd: 'End the hunt and go back to characters',
    navCharacter: 'Character',
    navHunt: 'Hunt',
    navTask: 'Task',
    navParty: 'Party',
    navWiki: 'Wiki',
    navRanking: 'Ranking',
    navOptions: 'Options',
    navPrey: 'Prey',
    navFriends: 'Friends',
    navGuild: 'Guild',
    navSupport: 'Contact us',
    navInvite: 'Invite',
    navMore: 'More',
    navPremium: 'Premium',
    chatGlobal: 'Global',
    chatMarket: 'Market',
    chatLocal: 'Local',
    chatPhLocal: 'Say something nearby...',
    chatParty: 'Party',
    chatPhParty: 'Message your party...',
    chatSystem: 'System',
    chatCombat: 'Combat',
    chatSend: 'Send',
    chatNeedLevel: 'You need level 20 to talk in this channel.',
    chatPhGlobal: 'Talk to everyone online...',
    chatPhMarket: 'Announce buys and sells...',
    chatCombatHint: 'What your character does in combat shows up here.',
  },
} as const;

export type MessageKey = keyof typeof STRINGS.pt;
